import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import {
  BASE_URL,
  AGENT_BANNER_CREATE,
  AGENT_BANNER_LIST,
  AGENT_BANNER_UPDATE,
  AGENT_BANNER_DELETE,
  M_POST
} from '@/utils/api';

@Module({ name: 'agentbanner' })
export default class AgentBanner extends VuexModule {
  list: unknown[] = [];

  @Mutation
  mutateAgentBanner(agentbanner: unknown[]) {
    this.list = agentbanner;
  }

  @Action({ commit: 'mutateAgentBanner', rawError: true })
  async FetchAgentBanner(params: Record<string, unknown> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + AGENT_BANNER_LIST,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch agent banner failed');
      return data?.data;
    } catch (err) {
      throw toError(err, 'Fetch agent banner failed');
    }
  }

  @Action({ rawError: true })
  async CreateAgentBanner(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + AGENT_BANNER_CREATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Create agent banner failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Create agent banner failed');
    }
  }

  @Action({ rawError: true })
  async UpdateAgentBanner(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + AGENT_BANNER_UPDATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update agent banner failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Update agent banner failed');
    }
  }

  @Action({ rawError: true })
  async DeleteAgentBanner(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + AGENT_BANNER_DELETE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Delete agent banner failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Delete agent banner failed');
    }
  }
}
